<template>
  <div v-if="navbarTitle !=''"
       class="w-full border-b-1 border-b-solid border-b-gray-200 flex flexCenter font-semibold text-xs text-primary-800 sticky top-0 bg-gray-900 z-30 w-full md:max-w-md mx-auto pt-safe px-4"
       style="padding-top: 0.75rem; min-height: 3rem;">
    {{ navbarTitle }}
  </div>
  <div class="flex flex-col w-full h-full bg-black grow-1">
    <NuxtPage class="grow-1 pb-36"/>
    <TheNavbar/>
  </div>
</template>

<script lang="ts" setup>
const navbarTitle = useState('navbarTitle')
</script>